class PLPBannerController extends window.StimulusController {
  static targets = [
    "toggleDescription",
    "showMore",
    "showLess",
    "description",
    "caret",
  ];

  connect() {
    this.checkOverflow();
  }

  checkOverflow() {
    const description = this.descriptionTarget;
    const isOverflowing = description.scrollHeight > description.clientHeight;
    this.toggleDescriptionTarget.classList.toggle(
      "tw-opacity-0",
      !isOverflowing,
    );
    this.toggleDescriptionTarget.classList.toggle(
      "tw-pointer-events-none",
      !isOverflowing,
    );
  }

  toggleShowMore() {
    this.showMoreTarget.classList.toggle("tw-hidden");
    this.showLessTarget.classList.toggle("tw-hidden");
    this.caretTarget.classList.toggle("tw-rotate-180");
    this.descriptionTarget.classList.toggle("tw-h-20");
  }
}

Stimulus.register("plp-banner", PLPBannerController);
